import React, { Component } from 'react';
import { Hero } from '../../styles/Jumbotron';

class IndexHeroComponent extends Component {
  handleModalOpen = () => {
    this.props.handleModalOpen();
  };

  handleVideoModalOpen = () => {
    this.props.handleVideoModalOpen();
  };

  render() {
    return (
      <Hero>
        <div className="container">
          <h1>Small-Business Software with a Human</h1>
          <div>
            <p>
              Sign up and receive a 30 day free trial and a consultation to set up your
              account.
            </p>
          </div>
          <div className="row justify-content-md-center">
            <div className="col-sm-12 col-md-10 col-lg-8 col-xl-6">
              <div className="row justify-content-center">
                <div className="col-sm-6">
                  <button
                    type="button"
                    className="btn btn-primary btn-block"
                    onClick={this.handleModalOpen}
                  >
                    Start for Free
                  </button>
                </div>
                {/* <div className="col-sm-6">
                  <button
                    type="button"
                    className="btn btn-clear btn-play btn-block"
                    onClick={this.handleVideoModalOpen}
                  >
                    Watch Video
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </Hero>
    );
  }
}

export default IndexHeroComponent;
